<nav id="nav-bar"
     class="navbar p-0">
  
  <ul class="nav">
    <li>
      <a class="logo nav-item" href="#home" (click)="onLogo()">
        <img src="/assets/img/LogoPorfolioAlter.svg" alt="DDO logo">
      </a>
    </li>
    <li [ngClass]="{'selected': link.key=== selected}"
        *ngFor="let link of links">
      <a class="nav-item d-none d-md-block"
         (click)="onSelectItem($event,link.key)"
         href="#{{link.key}}">
        <span>{{link.name}}</span>
        <div id="underline"
             class="underline-animation"></div>
      </a>
    </li>
    <li class="d-block d-md-none">
<button type="button" aria-label="Abrir menú" (click)="toggleMenu()" class="menu-btn">
    &#9776;
  </button>
    </li>
  </ul>

  <nav [ngClass]="{open: open,'mobile-nav': true}">
    <ul>
      <li *ngFor="let link of links" [ngClass]="{'selected': link.key === selected}">
        <a href="#{{link.key}}" (click)="closeMenu()">{{ link.name }}</a>
      </li>
    </ul>
  </nav>
</nav>
